import { gql } from '@apollo/client';

export const fetchPartnerProductEntitlements = gql`
  query fetchPartnerProductEntitlements(
    $searchParams: ProductEntitlementSearchParams
    $pageParams: ProductEntitlementPageParams
    $fetchIsExternallyEnabled: Boolean = false
  ) {
    partnerProductEntitlements(pageParams: $pageParams, searchParams: $searchParams) {
      pageInfo {
        endCursor
        hasNextPage
      }
      nodes {
        id
        logoId
        isApp
        relatesToEntitlements {
          entitlementId
          relationshipType
        }
        orgId
        orgName
        billedUsers
        billingCycle
        billingStatus
        billingFrequency
        cloudSiteId
        cloudSiteHostname
        provisioningStatus
        latestPeriodEndDate
        productName
        productId
        edition
        entitlementNumber
        linkedAppsId
        chargeQuantities {
          chargeElement
          quantity
        }
        shipTo {
          id
          fullName
          address {
            address1
            address2
            city
            state
            postalCode
            country
          }
        }
        isExternallyBilled @include(if: $fetchIsExternallyEnabled)
        billingGroupId
        pricingPlan {
          id
          type
        }
      }
    }
  }
`;
